export const baseRoute = '/listen';
export const downloadMediaRoute = '/listen/q/download-media';
export const locales = ['en', 'es', 'vi'];
export const defaultLocale = 'en';
export const localesData = {
  en: { name: 'English' },
  es: { name: 'Español' },
  vi: { name: 'Tiếng Việt' }
};
export function locale() {
  return (
    sessionStorage.getItem('locale') ||
    document.documentElement.lang ||
    defaultLocale
  );
}
export function syncDocumentLang() {
  document.documentElement.lang = locale();
}
export const accents = [
  'neutral',
  'gray',
  'red',
  'orange',
  'amber',
  'lime',
  'green',
  'teal',
  'cyan',
  'sky',
  'indigo',
  'purple',
  'fuchsia',
  'pink',
  'rainbow'
];

export const TYPOGRAPHY_DEFAULT = 'regular';
export const TYPOGRAPHY_ALTERNATIVE = 'regular-alternative';
export const CLASSES_TYPOGRAPHY_ALTERNATIVE = 'is-alternative-font';

export const typographies = [
  {
    id: TYPOGRAPHY_DEFAULT,
    name: 'Fira Sans'
  },
  {
    id: TYPOGRAPHY_ALTERNATIVE,
    name: 'Roboto'
  }
];

export const defaultAccent = 'gray';
export const defaultAmbient = 'auto';
export const DEFAULT_CROSSPLAYLIST_TRACKS_LIMIT = 6;
export const CHECK_LOGIN_INTERVAL = 300000;

export const PLAYBACK_HISTORY_LIMIT = 200;
export const PLAYBACK_MIN_LISTEN_MS = 30000;
export const PLAYBACK_MIN_FRACTION = 0.5;
export const RESUME_MIN_POSITION_MS = 5000;
export const RESUME_MAX_FRACTION = 0.95;
export const RESUME_SAVE_INTERVAL_MS = 10000;
export const PLAYBACK_COUNTS_TTL_MS = 300000;

export const WALLPAPER_DEFAULT = {
  name: 'Bowkey',
  value: '735812-bowkey'
};
export const WALLPAPER_URL_BASE = '/listen/assets/image/body-background';

export const wallpapers = [
  WALLPAPER_DEFAULT,
  {
    name: 'Abstract',
    value: '1317559-abstract'
  },
  {
    name: 'Abstract 2',
    value: '1509534-multicolored-abstract-painting'
  },
  {
    name: 'Blurred bokeh',
    value: '6321746-blurred-bokeh'
  },
  {
    name: 'Colorful Neon',
    value: '9834375-colorful-neon'
  },
  {
    name: 'ER',
    value: '15885025-er'
  },
  {
    name: 'Blue Yellow Bokeh',
    value: 'blue-yellow-bokeh-159027'
  },
  {
    name: 'Band playing on stage',
    value: 'band-playing-on-stage-2747446'
  },
  {
    name: 'Yellow star lanterns',
    value: 'yellow-star-lanterns-980859'
  }
];

const mediaTestUrl = `${baseRoute}/assets/media/test/sample`;
export const testSamples = {
  mp3: `${mediaTestUrl}.mp3`,
  flac: `${mediaTestUrl}.flac`,
  m4a: `${mediaTestUrl}.m4a`,
  ogg: `${mediaTestUrl}.ogg`,
  opus: `${mediaTestUrl}.opus`,
  wav: `${mediaTestUrl}.wav`,
  mp4: `${mediaTestUrl}.mp4`,
  webm: `${mediaTestUrl}.webm`
};
